<template>
  <v-container fluid>
    <vue-custom-scrollbar class="scroll-area">
    <v-flex>

      <v-card>
      <v-card-title>
            <span class="title">Results Parser</span>

            </v-card-title>
            You can merge between results of 2 services here and export to excel as well
            <br>
            e.g. Check the same IMEI on simlock & FMI and get an excel sheet for both results in the same row
            <br>
            Click on any header to sort the data
<br><br>

 <v-layout row wrap>

<v-flex xs2 sm6 md3>
            <v-text-field single-line outline placeholder="list1,list2 Get it from List# in history" label="List" light v-model="lists"></v-text-field>

</v-flex>
<v-flex xs5 sm6 md3>
  <v-btn class="blue-grey" flat="flat" @click="fetchOrders">Parse</v-btn>
  <v-btn class="blue-grey" fab small dark @click.native.stop="rightDrawer = !rightDrawer">
    <v-icon>edit</v-icon>
  </v-btn>
  </v-flex>

  <v-flex xs5 sm3 md1>
    <download-excel :data="sortedItems" type="csv" :fields="excelHeaders" :name="getFileName()">  <v-btn class="blue-grey" flat="flat">Export</v-btn></download-excel>
    </v-flex>
    <parser-panel :rightDrawer="rightDrawer" @cancelSearch="cancelSearch">
    <div v-for="header in fullheaders">
    <input type="checkbox" v-bind:value="header" v-model="headers"> {{header}}
    </div>
      </parser-panel>

   </v-layout>


    <table border="1" style="width:50%">
       <thead>

           	<th v-for="header in headers" :class="{ sorted: sort === header }" @click="sortBy(header)"> <a>{{ header}} </a></th>


</a>
           </th>
       </thead>
       <tbody>
         <tr v-for="item in sortedItems" border="1" style="border: solid">
           <td v-for="header in headers">{{item[header]}}</td>
         </tr>
       </tbody>
     </table>


     </v-card>

     </v-flex>
        </vue-custom-scrollbar>
</v-container>

</template>
<script>
/* globals Store */
import { mapState } from "vuex";
import { debounce } from "lodash";
import api from "@/utils/backend-api";
import Vue from 'vue'
import JsonExcel from 'vue-json-excel'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import ParserPanel from "@/components/ParsePanel.vue";

Vue.component('downloadExcel', JsonExcel)


export default {
  watch: {
    headers: function () {
      if (this.headers !== null)
      {
        this.excelHeaders = {};
        for (var i = 0; i < this.headers.length; ++i){
          this.excelHeaders[this.headers[i]] = this.headers[i];
        }
      }
    }
  },
  components: {
    vueCustomScrollbar,
    ParserPanel
  },
  data () {
    return {
      lists: "",
      headers: [],
      fullheaders: [],
      items: [],
      sort: '',
      sortDir: 'asc',
      loading: false,
      rightDrawer: false,
      excelHeaders: {}
    }
  },
  computed: {
  sortedItems: function() {
  if (this.sort !== ''){
     return this.items.sort((a, b) => {
       let dir = (this.sortDir === 'asc') ? 1 : -1;
       if (a[this.sort] < b[this.sort]) {
         return -1 * dir;
       } else if (a[this.sort] > b[this.sort]) {
         return  1 * dir;
       } else {
         return 0;
       }
     });
     }
     else {
     return this.items;
     }
   },


    },

  methods: {
  sortBy: function(s) {
      if (s === this.sort) {
        this.sortDir = (this.sortDir === 'asc') ? 'desc' : 'asc';
      } else {
        this.sortDir = 'asc';
      }
      this.sort = s;
    },
    isActiveSort: function(s) {
      return this.sort === s;
    },
    fetchOrders () {
    api.getData("fetchOrders.php?lists=" + this.lists).then(res => {
        this.headers = res.data.shift();
        this.fullheaders = this.headers;
        this.items = res.data;


    })
    .catch(err => {
      console.log(err);
      Store.dispatch('user/logout')
      location.reload()
    });
    },
    renderData: (item, header) => {
      let val = "";
      if (header.includes('.')) {
        const vals = header.split('.')
        val = vals.reduce((acc, val) => acc[val], item)
      } else {
        console.log(item);
        val = item[header]
      }
      if (typeof val === "boolean") {
        val = val ? "Yes" : "No";
      }
      return val;
    },
    getFileName (){
      var d = new Date();
      // return window.location.hostname + d + ".xls";
      return window.location.hostname + " - " + this.lists + ".xls";
    },

    closeSnackbar () {
      Store.commit("orders/setSnackbar", { snackbar: false });
      Store.commit("orders/setNotice", { notice: "" });
    },
    cancelSearch () {
      this.rightDrawer = false;
    },
  }
}
</script>

<style >
.scroll-area {
  position: relative;
  margin: auto;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// Parser.vue?09f81fc9